import React, { useState } from "react";
import { Button, ButtonGroup, Dropdown, DropdownButton, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { DevForm } from "@components/Forms/Fields";
import { Awesome, DevModal, OrderingHeader, YesNoColumn } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function MarketEnazaScreen() {
    return (
        <DefaultLayout>
            <List />
        </DefaultLayout>
    );
}

function List() {
    const { t } = useTranslation();
    const { apiData, setApiData, apiUrl } = useAppApi(url_reverse("api:market:enaza:list"));
    const { api_post } = useRequest();
    const [productInfo, setProductInfo] = useState(null);
    const [checkInfo, setCheckInfo] = useState(null);

    if (!apiData) return;

    const doMultiAction = (ev, enaza_ids) => {
        api_post(ev, apiUrl, {
            params: { action: ev.target.name, enaza_ids },
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData(resp);
                }
            },
        });
    };

    const createGame = (ev, enaza_id) => {
        api_post(ev, apiUrl, {
            params: { action: ev.currentTarget.name, enaza_id },
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData(resp);
                    setCheckInfo(null);
                }
            },
        });
    };

    const fullImport = (ev) => {
        api_post(ev, apiUrl, {
            params: { action: "update_catalog_full" },
            then: (resp) => {
                if (resp.status === "ok") {
                    alert("Запущен");
                }
            },
        });
    };

    const findDupls = (ev) => {
        api_post(ev, apiUrl, {
            params: { action: ev.currentTarget.name },
            then: (resp) => {
                if (resp.status === "ok") {
                    alert("Письмо будет отправлено по готовности");
                }
            },
        });
    };

    const checkData = (ev, enaza_id) => {
        api_post(ev, apiUrl, {
            params: { action: ev.currentTarget.name, enaza_id },
            then: (resp) => {
                if (resp.status === "ok") {
                    if (resp.err) {
                        setCheckInfo({ err: resp.err, enaza_id });
                    } else {
                        createGame(ev, enaza_id);
                    }
                }
            },
        });
    };

    const header = (
        <>
            {t("Каталог Enaza")} <small>({apiData.pager?.count})</small>
        </>
    );

    const showProductInfo = (ev, info) => {
        ev.preventDefault();
        setProductInfo(info);
    };

    const headerTools = (
        <>
            <Button href="#" variant="dark" size="sm" onClick={fullImport}>
                {t("Запустить полный импорт")}
            </Button>{" "}
            <Button href="#" variant="dark" size="sm" name="find_dupls" onClick={findDupls}>
                {t("Поиск совпадений с букой")}
            </Button>{" "}
            <DropdownButton as={ButtonGroup} size="sm" variant="dark" title={t("С выбранными")}>
                <Dropdown.Item
                    name="update"
                    onClick={(ev) => {
                        const enaza_ids = apiData.object_list.filter((o) => o.chosen).map((o) => o.enaza_id);
                        if (enaza_ids.length) {
                            doMultiAction(ev, enaza_ids);
                        }
                    }}
                >
                    {t("Обновить")}
                </Dropdown.Item>
                <Dropdown.Item
                    name="publish"
                    onClick={(ev) => {
                        const enaza_ids = apiData.object_list.filter((o) => o.chosen).map((o) => o.enaza_id);
                        if (enaza_ids.length) {
                            doMultiAction(ev, enaza_ids);
                        }
                    }}
                >
                    {t("Опубликовать")}
                </Dropdown.Item>
                <Dropdown.Item
                    name="unpublish"
                    onClick={(ev) => {
                        const enaza_ids = apiData.object_list.filter((o) => o.chosen).map((o) => o.enaza_id);
                        if (enaza_ids.length) {
                            doMultiAction(ev, enaza_ids);
                        }
                    }}
                >
                    {t("Снять с публикации")}
                </Dropdown.Item>
                <Dropdown.Item
                    name="to_black_list"
                    onClick={(ev) => {
                        const enaza_ids = apiData.object_list.filter((o) => o.chosen).map((o) => o.enaza_id);
                        if (enaza_ids.length) {
                            doMultiAction(ev, enaza_ids);
                        }
                    }}
                >
                    {t("Добавить в черный список")}
                </Dropdown.Item>
                <Dropdown.Item
                    name="from_black_list"
                    onClick={(ev) => {
                        const enaza_ids = apiData.object_list.filter((o) => o.chosen).map((o) => o.enaza_id);
                        if (enaza_ids.length) {
                            doMultiAction(ev, enaza_ids);
                        }
                    }}
                >
                    {t("Убрать из черного списка")}
                </Dropdown.Item>
            </DropdownButton>
        </>
    );

    return (
        <ListingCard header={header} headerTools={headerTools}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th style={{ width: "25px" }} />
                        <th>Enaza ID</th>
                        <th></th>
                        <th>
                            <OrderingHeader title={t("Игра")} attr="name" />
                        </th>
                        <th>
                            <OrderingHeader title={t("Базовая цена Enaza")} attr="price_base" />
                        </th>
                        <th>
                            <OrderingHeader title={t("Итоговая цена Enaza")} attr="price_final" />
                        </th>
                        <th>
                            <OrderingHeader title={t("Базовая цена РРЦ Enaza")} attr="price_base_rrc" />
                        </th>
                        <th>
                            <OrderingHeader title={t("Итоговая цена РРЦ Enaza")} attr="price_final_rrc" />
                        </th>
                        <th>{t("Территория активации")}</th>
                        <th>{t("Цена VK Play")}</th>
                        <th>{t("Цена со скидкой VK Play")}</th>
                        <th>
                            <OrderingHeader title={t("Предзаказ")} attr="is_preorder" />
                        </th>
                        <th>
                            <OrderingHeader title={t("Опубликован Enaza")} attr="is_published" />
                        </th>
                        <th>{t("Опубликовано на VK Play")}</th>
                        <th>{t("Наличие ключей")}</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((obj, i) => (
                        <tr key={`object_list${i}`} style={{ backgroundColor: obj.is_black_listed ? "#6c757d59" : "" }}>
                            <td>
                                <DevForm.Checkbox
                                    checked={obj.chosen}
                                    onChange={(ev) => {
                                        const newApiData = { ...apiData };
                                        newApiData.object_list.map((o) => {
                                            if (o.id === obj.id) {
                                                o.chosen = ev.target.checked;
                                            }
                                            return o;
                                        });
                                        setApiData(newApiData);
                                    }}
                                />
                            </td>
                            <td>{obj.enaza_id}</td>
                            <td>
                                {!obj.__enz_game.id && obj.is_published && (
                                    <DevForm.Button
                                        variant="warning"
                                        size="sm"
                                        name="check_data"
                                        value={obj.enaza_id}
                                        onClick={(ev) => checkData(ev, obj.enaza_id)}
                                    >
                                        <Awesome type="plus" tooltip={t("Создать")} />
                                    </DevForm.Button>
                                )}
                            </td>
                            <td>
                                {obj.__enz_game.id ? (
                                    <Link to={url_reverse("games:admin", { game_id: obj.__enz_game.id })}>
                                        {obj.name}
                                    </Link>
                                ) : (
                                    obj.name
                                )}
                            </td>
                            <td>{obj.price_base}</td>
                            <td>{obj.price_final}</td>
                            <td>{obj.price_base_rrc}</td>
                            <td>{obj.price_final_rrc}</td>
                            <td>{obj.product_data.territory_activation}</td>
                            <td>{obj.__enz_game.id ? obj.__enz_game.price_rub : ""}</td>
                            <td>{obj.__enz_game.id ? obj.__enz_ci.actual_cost : ""}</td>

                            <td>
                                <YesNoColumn attr={obj.is_preorder} />
                            </td>
                            <td>
                                <YesNoColumn attr={obj.is_published} />
                            </td>
                            <td>
                                <YesNoColumn attr={obj.__enz_game.catalog_is_published} />
                            </td>
                            <td>
                                <YesNoColumn attr={obj.is_available} />
                            </td>
                            <td>
                                <a href="" onClick={(ev) => showProductInfo(ev, obj.product_data)}>
                                    <Awesome type="info-circle" />
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <DevModal
                size="xl"
                show={productInfo}
                onHide={() => setProductInfo(null)}
                body={<pre>{JSON.stringify(productInfo, null, 2)}</pre>}
            />

            <DevModal
                size="lg"
                show={checkInfo}
                onHide={() => setCheckInfo(null)}
                header={t("Ошибки")}
                body={checkInfo && <div dangerouslySetInnerHTML={{ __html: checkInfo.err }} />}
                footer={
                    checkInfo && (
                        <>
                            <Button variant="light" onClick={() => setCheckInfo(null)}>
                                {t("Отмена")}
                            </Button>
                            <DevForm.Button
                                variant="primary"
                                name="create_game"
                                onClick={(ev) => createGame(ev, checkInfo.enaza_id)}
                            >
                                {t("Создать проект")}
                            </DevForm.Button>
                        </>
                    )
                }
            />
        </ListingCard>
    );
}
